import { Check, Circle } from "lucide-react";

interface OnboardingItemProps {
  completed: boolean;
  description: string;
}

export const OnboardingItem = ({ completed, description }: OnboardingItemProps) => {
  return (
    <div className="flex items-center py-2">
      <div className="w-[30px]">
      <div className="relative w-5 h-5">
        {completed ? (
          <div className="absolute inset-0 flex items-center justify-center rounded-full bg-green-500">
            <Check className="w-3 h-3 text-white" />
          </div>
        ) : (
          <Circle className="w-5 h-5 text-muted-foreground" />
        )}
      </div>
      </div>
      <span className="text-sm text-muted-foreground">{description}</span>
    </div>
  );
};